import { type HTMLArkProps, ark } from '@ark-ui/react';

import type { ActionColor, Radius, Scale4 } from '../../lib/types';
import { cn } from '../../lib/utils';

type IconButtonProps = Omit<HTMLArkProps<'button'>, 'color'> & {
	variant?: 'classic' | 'solid' | 'outline' | 'ghost' | 'soft' | 'surface';
	size?: Scale4;
	color?: ActionColor;
	radius?: Radius;
};

function IconButton({
	className,
	variant = 'solid',
	size = '2',
	color = 'accent',
	radius,
	...props
}: IconButtonProps) {
	return (
		<ark.button
			data-slot="icon-button"
			data-variant={variant}
			data-size={size}
			data-accent-color={color}
			data-radius={radius}
			className={cn('pt-icon-button', className)}
			{...props}
		/>
	);
}

export { IconButton, type IconButtonProps };
